module.exports = __webpack_public_path__ + "static/media/stop.292b97fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toolbar/icons/stop.svg
// module id = 917
// module chunks = 53